import invoicesService from '@/services/invoices.service'

export default {
  // 📋 Fetch invoices list
  async fetchInvoices({ commit, state }, payload = {}) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)

    try {
      const filters = { ...state.filters, ...payload }
      commit('SET_FILTERS', filters)

      const res = await invoicesService.getInvoices(filters)


      commit('SET_INVOICES', res.data)
      commit('SET_PAGINATION', res.meta)

      return res
    } catch (err) {
      commit('SET_ERROR', err.response?.data?.message || 'Failed to fetch orders')
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // 👤 Get single invoice
    async fetchInvoice({ commit }, id) {
      commit('SET_LOADING', true)
  
      try {
        const invoice = await invoicesService.getInvoice(id)
        commit('SET_INVOICE', invoice)
        return invoice
      } catch (err) {
        commit('SET_ERROR', err.response?.data?.message || 'Failed to fetch order')
      } finally {
        commit('SET_LOADING', false)
      }
    },
}